import ko from './ko/index';
import en from './en/index';
import vi from './vi/index';
import zh from './zh/index';

const messages = {
    ko,
    en,
    vi,
    zh,
};

export default messages;
